import { render } from "./FavButton.vue?vue&type=template&id=c6470078"
import script from "./FavButton.vue?vue&type=script&lang=js"
export * from "./FavButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__